import CryptoJS from "crypto-js";
//泰州
const appkey = "m429q7pov00w0asn88";
const app_secret = "1bbc83a94d2c9d14c002aef7790fc6d2";
//靖江
// const appkey = "afkpqsvxyALMPRSUY1";
// const app_secret = "9c4c6c5c789a313d1a494968bd46d0ec";
//泰兴
// const appkey = "bcghlnqtuwzAHINRZ1";
// const app_secret = "9eb640f4832218ea249d48d5394bda82";
// 时间戳
const getTimestamp = () => {
  return new Date().getTime();
};

// 6位随机数
const getNonce = () => {
  return Math.random()
    .toString(36)
    .substr(2, 6);
};

export const encrypt = (data = {}, cfg) => {
  const timestamp = getTimestamp();
  const nonce = getNonce();
  const crypto = {
    timestamp,
    appkey,
    nonce
  };
  // sign值
  const sign = md5Crypto(data, crypto);
  data.signField && delete data.signField;

  let result = {
    ...crypto,
    sign,
    ...data
  };

  if (!cfg) {
    return result;
  } else {
    let formData = new FormData();
    for (let key in result) {
      formData.append(key, result[key]);
    }
    return formData;
  }
};

// 处理签名字段 MD5加密
const md5Crypto = (paramsJson, crypto) => {
  // let { signField } = paramsJson;
  let signField = paramsJson.signField || [];
  // 获取需要签名的字段
  const cryptoParams = {
    ...crypto
  };
  signField.map(item => {
    cryptoParams[item] = paramsJson[item];
    return null;
  });

  // 排序
  const cryptoSort = sortObjByKey(cryptoParams);

  // 字符拼接
  let cryptoStr = "";
  Object.keys(cryptoSort).map(item => (cryptoStr += cryptoSort[item]));
  cryptoStr += app_secret;

  // md5加密
  const md5CryptoUpper = CryptoJS.MD5(cryptoStr)
    .toString()
    .toLocaleUpperCase();
  return md5CryptoUpper;
};

// 将通讯录按照 ABCD字母的顺序排序
const sortObjByKey = obj => {
  const keys = Object.keys(obj).sort();
  const newObj = {};
  for (let i = 0; i < keys.length; i++) {
    const index = keys[i];
    newObj[index] = obj[index];
  }
  return newObj;
};
